/**
 * Ce que la lecture adaptée fait au TEXTE de l'énoncé, avant le rendu — le reste (police,
 * espacements, blocs) est l'affaire de la feuille (`ADAPTED_READING_CLASS`).
 *
 * Un geste, pur et partagé par les deux moteurs, pour que l'écran élève d'aujourd'hui et celui du
 * design system le reprennent tel quel : `withDataBox` regroupe les données marquées (le rôle
 * `enonce-donnee` du générateur) dans un encadré « À utiliser » en tête. L'énoncé, lui, se lit
 * toujours en entier, ses questions à la suite.
 */
const DATA_MARK = /<span class="enonce-donnee">([\s\S]*?)<\/span>/g

/**
 * L'encadré « À utiliser » en tête de l'énoncé : ses données, dans l'ordre, sans doublon. Un
 * `<span>` dans un paragraphe ordinaire, pas un bloc `<div>` : Mathpix (le moteur natif) rend un bloc
 * HTML tel quel, sans en composer les formules — une donnée « $V = 50$ mL » s'y lisait en LaTeX
 * brut. Pas de donnée marquée (énoncé ancien, tapé par le tuteur) : pas d'encadré.
 */
export function withDataBox(value: string): string {
    const data = Array.from(new Set(Array.from(value.matchAll(DATA_MARK), (match) => match[1].trim()))).filter(
        (datum) => datum !== ""
    )
    if (data.length === 0) return value

    const marks = data.map((datum) => `<span class="enonce-donnee">${datum}</span>`).join(" ")
    const box = `<span class="enonce-a-utiliser"><span class="enonce-a-utiliser-titre">À utiliser</span> ${marks}</span>`
    return [box, value].join("\n\n")
}
